import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CoreDeploymentQueryKeys } from "./keys";
import { ScheduleCoreDeploymentRequest } from "../../models/CoreDeployment/CoreDeploymentRun";

export default function useCoreDeploymentMutations() {
  const { post, put } = useApiHelper();
  const queryClient = useQueryClient();

  const schedule = useMutation({
    mutationFn: (request: ScheduleCoreDeploymentRequest) =>
      post("/core-deployments", request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CoreDeploymentQueryKeys.all() });
    },
  });

  const cancel = useMutation({
    mutationFn: (runId: string) => post(`/core-deployments/${runId}/cancel`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CoreDeploymentQueryKeys.all() });
    },
  });

  // Calls GitHub and Claude, so it can take a minute or two. A failure still updates the stored
  // error, hence the refetch on settle rather than on success.
  const generateOverview = useMutation({
    mutationFn: (runId: string) => post(`/core-deployments/${runId}/overview/generate`, {}),
    onSettled: (_data, _error, runId) => {
      queryClient.invalidateQueries({ queryKey: CoreDeploymentQueryKeys.overview(runId) });
    },
  });

  const saveCustomerText = useMutation({
    mutationFn: ({ runId, text }: { runId: string; text: string }) =>
      put(`/core-deployments/${runId}/overview/customer`, { text }),
    onSuccess: (_data, { runId }) => {
      queryClient.invalidateQueries({ queryKey: CoreDeploymentQueryKeys.overview(runId) });
    },
  });

  return {
    schedule,
    cancel,
    generateOverview,
    saveCustomerText,
  };
}
